import axios from '@/libs/axios'
import i18n from '@/libs/i18n'

export default {
  namespaced: true,
  state: {
    locale: i18n.locale, // default calendar locale based on active i18n locale
    calendarOptions: [
      {
        color: 'warning',
        label: 'ΑΙΘΟΥΣΑ BALLROOM II',
      },
      {
        color: 'success',
        label: 'ΑΙΘΟΥΣΑ BALLROOM III',
      },
      {
        color: 'info',
        label: 'ΑΙΘΟΥΣΑ ΥΨΙΛΟΝ',
      },
    ],
    selectedCalendars: ['ΑΙΘΟΥΣΑ BALLROOM II', 'ΑΙΘΟΥΣΑ BALLROOM III'],
  },
  getters: {
    LOCALE: state => state.locale,
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale
    },

    SET_SELECTED_EVENTS(state, val) {
      state.selectedCalendars = val
    },
  },
  actions: {
    fetchEvents(ctx, { calendars }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/calendar/events', {
            params: {
              calendars: calendars.join(','),
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addEvent(ctx, { event }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/calendar/events', { event })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEvent(ctx, { event }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/apps/calendar/events/${event.id}`, { event })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeEvent(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/apps/calendar/events/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
